import { createAsyncThunk } from '@reduxjs/toolkit';
//import httpService from '@/rtk-apis/axios-config/http-service';
import { _patientUrls } from '@custom/Utils/constants/apiUrls';
import { getCloudPACSToken } from '@custom/Utils/authUtils';

const patientStudies = createAsyncThunk('patientList', async ({uhid}: { uhid: string }) => {
  try {
    let url = `${_patientUrls.studiesList}?limit=21&includefield=all&PatientID=${uhid}&offset=0`;
    const token = getCloudPACSToken();
    let response = await fetch(url, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      }
    })
    return await response.json()
  } catch (error) {
    return error;
  }
});

export default patientStudies;
